import { userApi } from './api/userApi';
import { slice } from './model/user.slice';
import { userSelectors } from './model/selectors/selectors';
import {
  userInit, getUserById, updateUser, createUser,
} from './model/actions';

export { userApi };
export const userSlice = slice.reducer;
export { userSelectors };
export {
  userInit, getUserById, updateUser, createUser,
};
